import React from 'react';
import PropTypes from 'prop-types';
import Collapsible from 'react-collapsible';

import './CollapsiblePanel.scss';

const propTypes = {
    panel: PropTypes.object,
}


export default class CollapsiblePanel extends React.Component {
    constructor (props) {
        super(props);
    }

    render() {

        const {panel} = this.props;
        const {question, answer} = panel;




        return(
            <div className='c-panel-holder'>
                <Collapsible trigger={question} transitionTime={200}>
                    <div className='c-panel-response'>
                        <p className='response-text'>{answer}</p>
                    </div>
                </Collapsible>
            </div>

        )

    }
}

CollapsiblePanel.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/CollapsiblePanel/index.js